import React from "react";
import {
  FaAddressBook,
  FaBookOpen,
  FaBuffer,
  FaChalkboardTeacher,
  FaCreditCard,
  FaFileSignature,
  FaListUl,
  FaMarker,
  FaStarAndCrescent,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";
import ArrowDownComponent from "../Components/ArrowDownComponent";
import { authenticated } from "../Store";
import StatusBoxStudent from "./StatusBoxStudent";

const DashboardStepBox = ({
  satPaidCount,
  satCount,
  steps,
  all_steps,
  formulir,
  exam,
  quran,
  program_mapping,
  program_name,
  sat,
  scholarship_status,
  is_accepted_regular_class,
  status_program_mapping,
}) => {
  const auth = useRecoilValue(authenticated);
  const statusColorBox = (
    status,
    is_accepted_regular_class,
    status_program_mapping,
    program_name
  ) => {
    if (status === "diterima") {
      return "bg-green-300";
    } else if (status === "tidak diterima") {
      if (
        program_name !== "Reguler" &&
        is_accepted_regular_class &&
        status_program_mapping === 0
      ) {
        return "bg-yellow-300";
      } else {
        return "bg-red-300";
      }
    } else if (status === "mengundurkan diri") {
      return "bg-yellow-300";
    } else {
      return "bg-gray-100";
    }
  };
  const statusName = (
    status,
    is_accepted_regular_class,
    status_program_mapping,
    program_name
  ) => {
    if (status === "diterima") {
      return "Diterima";
    } else if (status === "tidak diterima") {
      if (
        program_name !== "Reguler" &&
        is_accepted_regular_class &&
        status_program_mapping === 0
      ) {
        return "Diterima Reguler";
      } else {
        return "Tidak Diterima";
      }
    } else if (status === "mengundurkan diri") {
      return "Mengundurkan Diri";
    } else {
      return "Proses";
    }
  };
  const scholarshipColorBox = (status) => {
    if (status === "mendapat") {
      return "bg-green-300";
    } else if (status === "tidak dapat") {
      return "bg-yellow-300";
    } else {
      return "bg-gray-100";
    }
  };
  const arrowBox = (scholar_step, normal_step, program_mapping_step) => {
    if (scholarship_status) {
      return scholar_step;
    } else if (program_name !== "Reguler") {
      return program_mapping_step;
    } else {
      return normal_step;
    }
  };
  return (
    <div className="flex justify-center flex-wrap xl:flex-nowrap gap-y-24 gap-4 mt-20">
      <Link
        to={"/biodatas"}
        className={`${
          steps.biodata ? "bg-green-300" : "bg-gray-100"
        } rounded-2xl shadow-md w-40 p-4 relative transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-300 duration-300`}
      >
        <ArrowDownComponent size={40} step={all_steps} cond={"000000000"} />
        <FaAddressBook size={40} className="mx-auto mb-4" />
        <div className="uppercase text-center">isi formulir</div>
      </Link>
      <Link
        to={`${formulir !== null ? `/bills/${formulir}` : "#"}`}
        className={`${
          steps.form_pay ? "bg-green-300" : "bg-gray-100"
        } rounded-2xl shadow-md w-40 p-4 relative transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-300 duration-300`}
      >
        <ArrowDownComponent size={40} step={all_steps} cond={"100000000"} />
        <FaListUl size={40} className="mx-auto mb-4" />
        <div className="uppercase text-center wrapper">
          pembayaran
          <br />
          formulir
        </div>
      </Link>
      {scholarship_status ? (
        <div
          className={`${scholarshipColorBox(
            scholarship_status
          )} rounded-2xl shadow-md w-40 p-4 relative transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-300 duration-300`}
        >
          <ArrowDownComponent size={40} step={all_steps} cond={"110000000"} />
          <FaFileSignature size={40} className="mx-auto mb-4" />
          <div className="uppercase text-center wrapper">
            {scholarship_status} Beasiswa
          </div>
        </div>
      ) : (
        ""
      )}
      <Link
        to={`${exam !== null ? `/students/exam` : "#"}`}
        className={`${
          steps.online_test ? "bg-green-300" : "bg-gray-100"
        } rounded-2xl shadow-md w-40 p-4 relative transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-300 duration-300`}
      >
        <ArrowDownComponent
          size={40}
          step={all_steps}
          cond={arrowBox("111000000", "110000000", "110000000")}
        />
        <FaMarker size={40} className="mx-auto mb-4" />
        <div className="uppercase text-center">
          pemetaan masuk dan wawancara
        </div>
      </Link>
      <Link
        to={`${quran !== null ? `/students/quran` : "#"}`}
        className={`${
          steps.quran_test ? "bg-green-300" : "bg-gray-100"
        } rounded-2xl shadow-md w-40 p-4 relative transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-300 duration-300`}
      >
        <ArrowDownComponent
          size={40}
          step={all_steps}
          cond={arrowBox("111100000", "110100000", "110100000")}
        />
        <FaBookOpen size={40} className="mx-auto mb-4" />
        <div className="uppercase text-center">pemetaan qur'an</div>
      </Link>
      {program_name !== "Reguler" ? (
        <Link
          to={`${program_mapping !== null ? `/students/program-mapping` : "#"}`}
          className={`${
            steps.program_mapping_test ? "bg-green-300" : "bg-gray-100"
          } rounded-2xl shadow-md w-40 p-4 relative transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-300 duration-300`}
        >
          <ArrowDownComponent
            size={40}
            step={all_steps}
            cond={arrowBox("111100000", "110100000", "110110000")}
          />
          {program_name === "Tahfidz" && (
            <FaStarAndCrescent size={40} className="mx-auto mb-4" />
          )}
          {program_name === "Cambridge" && (
            <FaChalkboardTeacher size={40} className="mx-auto mb-4" />
          )}
          <div className="uppercase text-center">pemetaan {program_name}</div>
        </Link>
      ) : (
        ""
      )}
      <div
        className={`${statusColorBox(
          auth.user.status,
          is_accepted_regular_class,
          status_program_mapping,
          program_name
        )} rounded-2xl shadow-md w-40 p-4 relative transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-300 duration-300`}
      >
        <ArrowDownComponent
          size={40}
          step={all_steps}
          cond={arrowBox("111101000", "110101000", "110111000")}
        />
        <StatusBoxStudent
          status={auth.user.status}
          status_program_mapping={status_program_mapping}
          is_accepted_regular_class={is_accepted_regular_class}
          program_name={program_name}
        />
        <div className="uppercase text-center">
          {statusName(
            auth.user.status,
            is_accepted_regular_class,
            status_program_mapping,
            program_name
          )}
        </div>
      </div>
      <Link
        to={`${sat !== null ? `/bills/${sat}` : "#"}`}
        className={`${
          steps.sat_pay ? "bg-green-300" : "bg-gray-100"
        } rounded-2xl shadow-md w-40 p-4 relative transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-300 duration-300`}
      >
        <ArrowDownComponent
          size={40}
          step={all_steps}
          cond={arrowBox("111101100", "110101100", "110111100")}
        />
        {satCount > 0 ? (
          <span className="bg-red-500 text-white py-1 px-4 rounded absolute left-32 bottom-32 font-bold">
            {satCount && satPaidCount ? 2 : 1}
          </span>
        ) : (
          ""
        )}
        <FaCreditCard size={40} className="mx-auto mb-4" />
        <div className="uppercase text-center">pembayaran sat</div>
      </Link>
      <Link
        to={`${
          auth.user.status === "diterima" ? `/students/re/register` : "#"
        }`}
        className={`${
          steps.re_register ? "bg-green-300" : "bg-gray-100"
        } rounded-2xl shadow-md w-40 p-4 relative transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-300 duration-300`}
      >
        {auth.user.status === "diterima" ? (
          <ArrowDownComponent
            size={40}
            step={all_steps}
            cond={arrowBox("111101110", "110101110", "110111110")}
          />
        ) : (
          ""
        )}
        <FaBuffer size={40} className="mx-auto mb-4" />
        <div className="uppercase text-center">isi kelengkapan biodata</div>
      </Link>
    </div>
  );
};

export default DashboardStepBox;
